// Content approval as the campaign API exposes it: `content_approval_mode` is the single
// review setting, `story_approval_mode` says whether the story batch is reviewed too.
export type TContentApprovalMode = "ai_automated" | "manual" | "off" | "semi_automated";
export type TAiContentApprovalMode = Extract<TContentApprovalMode, "ai_automated" | "semi_automated">;
export type TStoryApprovalMode = "off" | "on";

export const AI_CONTENT_APPROVAL_MIN_CASH_REWARD = 70;
export const CONTENT_APPROVAL_MIN_CASH_REWARD = 150;
export const DEFAULT_AI_CONTENT_APPROVAL_THRESHOLD = 80;

export const MODE_MIN_CASH_REWARD: Record<TContentApprovalMode, number> = {
  ai_automated: AI_CONTENT_APPROVAL_MIN_CASH_REWARD,
  manual: CONTENT_APPROVAL_MIN_CASH_REWARD,
  off: 0,
  semi_automated: AI_CONTENT_APPROVAL_MIN_CASH_REWARD,
};

export const isAiContentApprovalMode = (
  mode: TContentApprovalMode | null | undefined,
): mode is TAiContentApprovalMode => mode === "ai_automated" || mode === "semi_automated";

export const hasContentApproval = (mode: TContentApprovalMode | null | undefined): boolean => !!mode && mode !== "off";

export const asContentApprovalMode = (value: string | null | undefined): TContentApprovalMode =>
  value === "ai_automated" || value === "manual" || value === "semi_automated" ? value : "off";

export const asStoryApprovalMode = (value: string | null | undefined): TStoryApprovalMode =>
  value === "on" ? "on" : "off";

// Stories are only reviewed by the AI-backed modes on Instagram campaigns that require
// stories (mirrors the backend default so the form shows the right state before the save
// round-trips).
export const defaultStoryApprovalMode = (
  mode: TContentApprovalMode,
  {isInstagram, numberOfStories}: {isInstagram: boolean; numberOfStories: number},
): TStoryApprovalMode => (isAiContentApprovalMode(mode) && isInstagram && numberOfStories > 0 ? "on" : "off");
